import * as React from 'react';

export interface PageWrapperProps {
    children?: any;
    className?: string;
}

export function PageWrapper(props: PageWrapperProps) {
    return (
        <div id='page-wrapper' className={props.className}>
            {props.children}            
        </div>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/PageWrapper.tsx